import { FC } from 'react';
import { styled } from 'styled-components';
import { useGetSessionBoardsQuery } from '../redux';

interface IBoards {
	sessionId: string;
}

export const BoardsTab: FC<IBoards> = ({ sessionId }) => {
	const { data: boards, isFetching } = useGetSessionBoardsQuery({ sessionId });

	if (isFetching) {
		return <div>Loading boards</div>;
	}

	if (boards?.length === 0) {
		return <div>No boards</div>;
	}

	return (
		<Container>
			{boards?.map(({ id, imgUrl }) => (
				<Board key={id}>
					<Image src={imgUrl} alt="Board image" />
				</Board>
			))}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	gap: 25px;
	flex-wrap: wrap;
`;

const Board = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 300px;
	height: fit-content;
	border: 1px solid #dbdbdb;
	padding: 10px;
	border-radius: 4px;
`;

const Image = styled.img`
	border: 1px solid #dbdbdb;
	/*height: 270px;
	width: 270px;*/
`;
